/**
 * otp-parts.tsx — Ô nhập mã 6 số + nút "Gửi lại mã" có đếm ngược (dùng ở Đăng ký và Quên mật khẩu).
 */
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Loader2 } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { formatCountdown, sanitizeOtp } from './auth-helpers'

export function OtpInput({ value, onChange, disabled, autoFocus = true }: {
  value: string
  onChange: (v: string) => void
  disabled?: boolean
  autoFocus?: boolean
}) {
  const { t } = useTranslation('authPages')
  return (
    <Input
      id="otp"
      value={value}
      onChange={(e) => onChange(sanitizeOtp(e.target.value))}
      inputMode="numeric"
      autoComplete="one-time-code"
      pattern="\d{6}"
      maxLength={6}
      placeholder="••••••"
      autoFocus={autoFocus}
      disabled={disabled}
      aria-label={t('otp.ariaLabel')}
      className="h-12 text-center font-mono text-2xl tracking-[0.5em]"
    />
  )
}

/** Đếm ngược theo mốc thời gian (không trôi khi tab ngủ). */
export function useCountdown(untilMs: number): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (untilMs <= Date.now()) return
    const t = window.setInterval(() => setNow(Date.now()), 500)
    return () => window.clearInterval(t)
  }, [untilMs])
  return Math.max(0, Math.ceil((untilMs - now) / 1000))
}

export function ResendButton({ until, onResend, disabled = false }: { until: number; onResend: () => Promise<void>; disabled?: boolean }) {
  const { t } = useTranslation('authPages')
  const left = useCountdown(until)
  const [busy, setBusy] = useState(false)
  if (left > 0) return <span className="text-sm text-muted-foreground">{t('otp.resendIn', { time: formatCountdown(left) })}</span>
  return (
    <button
      type="button"
      className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline disabled:opacity-60"
      disabled={busy || disabled}
      onClick={async () => {
        setBusy(true)
        try {
          await onResend()
        } finally {
          setBusy(false)
        }
      }}
    >
      {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />} {t('otp.resend')}
    </button>
  )
}
